export default "__VITE_ASSET__50efd442__"